import React from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";

export default function CountryMarquee() {
  const { categories } = useContent();
  const row = [...categories].sort((a, b) => b.count - a.count);
  const doubled = [...row, ...row];
  return (
    <section data-testid="country-marquee" aria-label="Categories" className="bg-stone-900 text-stone-200 py-8 overflow-hidden border-y border-stone-800">
      <div className="flex whitespace-nowrap marquee-track">
        {doubled.map((c, i) => (
          <Link
            key={`${c.slug}-${i}`}
            to={`/category/${c.slug}`}
            data-testid={i < row.length ? `marquee-link-${c.slug}` : undefined}
            className="flex items-center gap-10 pr-10 font-serif text-2xl sm:text-4xl font-light hover:text-[#B45309] transition-colors"
          >
            <em className="italic opacity-80">{c.name}</em>
            <span className="text-[#B45309] text-xs">✦</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
